module.exports = __webpack_public_path__ + "static/media/Yellow_Shapes.a837395d.png";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/LandingPage/Components/Footer/img/Yellow_Shapes.png
// module id = 71
// module chunks = 0